interface LabelCheckBoxProps {
  isChecked: boolean;
  onChange: (e: any) => void;
  label: string;
  className?: string;
  key: string;
  disabled?: boolean;
  checkedColor?: string;
}

const LabelCheckBox = ({
  isChecked, onChange, label, className,
  key, disabled = false, checkedColor
}: LabelCheckBoxProps) => {
  const cursor = disabled ? 'cursor-not-allowed' : 'cursor-pointer';
  return (
    <div className={`${className ?? ''}`}>
      <label htmlFor={key} className={`whitespace-nowrap text-sm inline-flex items-center relative ${cursor}`}>
        <input disabled={disabled} id={key} name={`${label}-${key}`} type="checkbox" className={`relative peer shrink-0
      appearance-none w-4 h-4 mr-2 border border-neutral-40 rounded bg-white dark:bg-grey-800
      ${checkedColor === 'primary' ? 'checked:bg-primary-600 checked:dark:bg-primary-600' : 'checked:bg-blue-500 checked:dark:bg-blue-500'} checked:border-0 ${cursor}`} checked={isChecked} onChange={onChange} />

        <span className={`font-Inter ${disabled ? 'text-gray-105 ' : ''}`}>{label}</span>

        <span className={'absolute hidden peer-checked:flex items-center justify-center w-4 h-4'}>
          <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.24503 1.59009L3.99503 5.84009L1.74503 3.59009" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </label>
    </div>
  );
};
export default LabelCheckBox;
